import React from "react";
import { InputAdornment } from "@mui/material";
import PropTypes from "prop-types";

import RenderFields from "Components/RenderFields";
import { onlyNumberKeys } from "utils";

export const inputFields = [
  {
    header: "Meter Display Details:",
  },
  {
    label: "RN",
    name: "meterDisplayDetail.rn",
    placeholder: "Enter RN",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "YN",
    name: "meterDisplayDetail.yn",
    placeholder: "Enter YN",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "BN",
    name: "meterDisplayDetail.bn",
    placeholder: "Enter BN",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "KW",
    name: "meterDisplayDetail.kw",
    placeholder: "Enter KW",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "IR",
    name: "meterDisplayDetail.ir",
    placeholder: "Enter IR",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "IY",
    name: "meterDisplayDetail.iy",
    placeholder: "Enter IY",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "IB",
    name: "meterDisplayDetail.ib",
    placeholder: "Enter IB",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "PF",
    name: "meterDisplayDetail.pf",
    placeholder: "Enter PF",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  { header: "Accucheck Details:" },
  {
    label: "RN",
    name: "accucheckDetail.rn",
    placeholder: "Enter RN",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "YN",
    name: "accucheckDetail.yn",
    placeholder: "Enter YN",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "BN",
    name: "accucheckDetail.bn",
    placeholder: "Enter BN",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "PF",
    name: "accucheckDetail.pf",
    placeholder: "Enter PF",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "IR",
    name: "accucheckDetail.ir",
    placeholder: "Enter IR",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "IY",
    name: "accucheckDetail.iy",
    placeholder: "Enter IY",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "IB",
    name: "accucheckDetail.ib",
    placeholder: "Enter IB",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "HZ",
    name: "accucheckDetail.hz",
    placeholder: "Enter HZ",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "Phase Sequence",
    name: "accucheckDetail.phaseSequence",
    placeholder: "Enter phase sequence",
  },
  {
    label: "P",
    name: "accucheckDetail.p_KW",
    placeholder: "Enter P",
    InputProps: {
      endAdornment: <InputAdornment position="end">KW</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "Q",
    name: "accucheckDetail.q_KVAR",
    placeholder: "Enter Q",
    InputProps: {
      endAdornment: <InputAdornment position="end">KVAR</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "S",
    name: "accucheckDetail.s_KVA",
    placeholder: "Enter S",
    InputProps: {
      endAdornment: <InputAdornment position="end">KVA</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "F",
    name: "accucheckDetail.f_KWH",
    placeholder: "Enter F",
    InputProps: {
      endAdornment: <InputAdornment position="end">KWH</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  { header: "Meter Reading During Test:" },
  {
    label: "Final",
    name: "meterReadingTest.final",
    placeholder: "Enter Final",
    InputProps: {
      endAdornment: <InputAdornment position="end">KWH</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "Initial",
    name: "meterReadingTest.initial",
    placeholder: "Enter Initial",
    InputProps: {
      endAdornment: <InputAdornment position="end">KWH</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "Diff",
    name: "meterReadingTest.difference",
    placeholder: "Enter Diff",
    InputProps: {
      endAdornment: <InputAdornment position="end">KWH</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
  {
    label: "error",
    name: "meterReadingTest.error",
    placeholder: "Enter error",
    InputProps: {
      endAdornment: <InputAdornment position="end">%</InputAdornment>,
    },
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
];

const AccucheckTest = ({ formik }) => (
  <RenderFields
    formik={formik}
    inputFields={inputFields}
    parentKey="accucheckTest"
  />
);

AccucheckTest.propTypes = {
  formik: PropTypes.object,
};

export default AccucheckTest;
